import creditCardImg from './../assets/images/transaction.png'
import cashImg from './../assets/images/dollars.png'
import checkImg from './../assets/images/payment-check.png'
import zelleImg from './../assets/images/zelle_logo.png'


export const getLogoByPaymentMethodName = (payMethodName) => {
    switch(payMethodName?.toLowerCase()){
        case 'card':
            return creditCardImg;
        case 'check':
            return checkImg;
        case 'cash':
            return cashImg;
        case 'zelle':
            return zelleImg;
        default:
            return creditCardImg;
    }
};